import { render, staticRenderFns } from "./war-zone.vue?vue&type=template&id=108a1111&scoped=true"
import script from "./war-zone.vue?vue&type=script&lang=js"
export * from "./war-zone.vue?vue&type=script&lang=js"
import style0 from "./war-zone.vue?vue&type=style&index=0&id=108a1111&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a1111",
  null
  
)

export default component.exports